module.exports = __webpack_public_path__ + "static/Facebook-Icon-White-5c690fc70976f9c23d1f2e38dbf6741c.png";